module.exports = __webpack_public_path__ + "static/media/face_sad.d6996740.svg";